import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {ReactKeycloakProvider} from "@react-keycloak/web"
import keycloak from "./auth/Keycloak";

import {setAccountProperties} from "./store/slices/accountSlice";
import UserService from "./api/extranet/services/UserService";
import { setPerimetersV2 } from "./store/slices/extranetSlice";
import SweetAlert from "sweetalert2";

import {resetAppAction} from "./store/rootReducer";
import ThemeCustomization from './layouts/MuiTheme/index';
import NavigationScroll from "./layouts/berry/NavigationScroll";
import Notistack from "./components/berry/ui-component/third-party/Notistack";
import Snackbar from "./components/berry/ui-component/extended/Snackbar";
import AppRouter from "./helpers/AppRouter";
import Locales from './components/berry/ui-component/Locales';
import Loader from './components/berry/ui-component/Loader';
import {ConfigProvider} from "./contexts/ConfigContext";

const App = () => {

    const account = useSelector(state => state.account)
    const extranet = useSelector(state => state.extranet)
    const loading = useSelector(state => state.loading.value)
    const dispatch = useDispatch();

    const supportsHistory = 'pushState' in window.history;

    const onHandleEvent = (event, error) => {

        switch (event) {
            case "onReady":
                // console.log("onReady")
                break;
            case "onInitError":
                // console.log("onInitError")

                SweetAlert.fire({
                    title: "Serveur d'autorisations injoignable",
                    html: `Vérifier que le serveur d'autorisation est opérationnel`,
                    reverseButtons: false,
                    allowOutsideClick: false
                })
                break;
            case "onAuthLogout":
                // console.log("onAuthLogout")

                // sessionStorage.clear();
                // localStorage.clear();
                resetAppAction(dispatch);
                // window.location.reload();
                break;
            default:
                if (sessionStorage.getItem('cypher') === null) {

                }
                return null
        }

    }

    const onHandleIsLoadingCheck = (keycloak) => {
        return !keycloak.didInitialize
    }

    const parseAuthTimeWithoutJwtDecode = (token) => {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error("Invalid JWT token");
        }
        const payload = tokenParts[1];
        const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        const authTime = decodedPayload.auth_time;
        return authTime;
    }

    const checkAuthTime = (token) => {
        const maxAge = 3600; // one hour
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        const authTime = parseAuthTimeWithoutJwtDecode(token);
        if (currentTime - authTime > maxAge) {
            // console.log('handleLogout')
            handleLogout()
        } else {
            console.log(`User authenticated at => ${new Date(authTime * 1000).toLocaleString()} - CurrentTime ${new Date(currentTime * 1000).toLocaleString()}`);
        }
    }

    const handleLogout = async () => {
        // sessionStorage.clear();
        // localStorage.clear();
        resetAppAction(dispatch);
        return await keycloak.logout({
            'redirectUri': window.location.origin + '/ui'
        });
    }

    const onHandleTokens = async (data) => {
        if (data.token !== undefined) {
            const userData = await UserService.getUser(data.token)
            if (typeof userData !== "undefined") {
                dispatch(setAccountProperties(userData))
                if (userData.perimetersV2 && userData.perimetersV2.length > 0) {
                    dispatch(setPerimetersV2(userData.perimetersV2))
                    const indexPerimeter = localStorage.getItem('idxPeri');
                }
            }
        } else {
            resetAppAction(dispatch);
        }
    }

    React.useEffect(() => {
        return () => {
            // keycloak.didInitialize = false;
        }
    }, [keycloak.authenticated])

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                onLoad: 'check-sso', //login-required
                checkLoginIframe: false,
            }}
            onEvent={onHandleEvent}
            onTokens={onHandleTokens}
            LoadingComponent={loading ? (
                <Loader />
            ) : null}
            isLoadingCheck={onHandleIsLoadingCheck}
        >
            <ConfigProvider>
                <ThemeCustomization>
                        <Locales>
                            <NavigationScroll>
                                <>
                                    <Notistack>
                                        <BrowserRouter forceRefresh={!supportsHistory}>
                                            <AppRouter user={account.user} />
                                        </BrowserRouter>
                                        <Snackbar/>
                                    </Notistack>
                                </>
                            </NavigationScroll>
                        </Locales>
                </ThemeCustomization>
            </ConfigProvider>
        </ReactKeycloakProvider>
    );
}

export default App;
